<template>
    <div class="download-container">
        <CommonComponentsButtonLine
            light
            transparent
            :button-text="t('global_link_button_6')"
            class="download-link-btn"
            :class="product"
            @click="goDownload()"
        />
    </div>
</template>

<script lang="ts" setup>
    import i18n from '@/locales';
    const { t } = i18n.global;
    const props = defineProps<{
        product: 'atelier' | 'simulator' | 'studio';
    }>();

    const goDownload = () => {
        switch (props.product) {
            case 'atelier':
                window.open('https://atelier.style3d.com/', '_blank');
                break;
            case 'simulator':
                window.open('https://simulator.style3d.com/', '_blank');
                break;
            case 'studio':
                window.open('https://studio.style3d.com/en', '_blank');
                break;
        }
    };
</script>

<style lang="less" scoped>
    .download-container {
        display: flex;
        justify-content: center;
        margin-top: .convert(60px) [ @vw];
        margin-bottom: .convert(40px) [ @vw];
        .download-link-btn {
            font-size: .convert(24px) [ @vw];
            border-radius: .convert(83px) [ @vw];
            letter-spacing: .convert(3.84px) [ @vw];

            :deep(.svg) {
                width: .convert(22px) [ @vw];
            }

            :deep(.button-flex-container) {
                padding: .convert(16px) [ @vw] .convert(26px) [ @vw];
            }
        }

        @media (max-width: @screen-mobile-width) {
            margin-top: .convert(20px) [ @vw-mobile];
            margin-bottom: .convert(15px) [ @vw-mobile];
            .download-link-btn {
                padding: .convert(8px) [ @vw-mobile] 0;
                font-size: .convert(14px) [ @vw-mobile];
                border-radius: .convert(83px) [ @vw-mobile];
                letter-spacing: .convert(2.24px) [ @vw-mobile];
            }
        }
    }
</style>
